import { api } from "./api";

export const getAlbums = async () => {
  const response = await api.get("/Album/all");
  return response.data;
};
export const getLatestAlbums = async () => {
  const response = await api.get("/Album/latest");
  return response.data;
};
export const getAlbumBySlug = async (slug) => {
    const res = await api.get(`/Album/by-slug/${slug}`);
    return res.data;
  };